<template>
	<div id="app" ref="appRef">
		<header role="navigation" class="navBar" id="header">
			<button v-show="false" class="hamburgerContainer" role="navigation">
				<div class="hamburgerIcon" title="Menu">
					<span class="line line-1"></span><span class="line line-2"></span
					><span class="line line-3"></span>
				</div>
			</button>
			<a style="cursor: pointer" class="logoWrap" @click="goHome()"
				><img
					class="logo"
					src="/images/govnadlan.png"
					alt="אתר הנדלן של ישראל"
					height="40"
			/></a>
			<section class="searchSection collapsed">
				<div class="accordion">
					<div class="collapse show">
						<div
							class="mobile-toggle-search"
							@click="searchMobileActive = !searchMobileActive"
						>
							<div class="magnifyWrap">
								<span
									v-if="
										searchMobileActive == false && $store.state.isMain == false
									"
								>
									<img src="/images/search.svg" height="30" alt="חיפוש" />
								</span>
								<span
									v-if="
										searchMobileActive == true && $store.state.isMain == false
									"
									class="close"
									>X</span
								>
							</div>
						</div>
						<SearchBox style="z-index: 1000000" v-if="$route.query.view != null"/>
					</div>
				</div>
			</section>
			<div class="headerActions">
				<button v-if="currentUser == null" type="button" @click="login()">
					<img
						src="/images/user/user.svg"
						:height="isMobile == true ? '30' : '40'"
						alt="התחברות"
					/>
				</button>
				<div v-else class="personalAreaNav">
					<div class="text">
						<button
							@click="toggleProfileDrop()"
							type="button"
							class="profileActionBtn"
						>
							<div class="initialCircle">
								{{ userLetters }}
								<span class="greenDot"></span>
							</div>
						</button>
						<div
							v-show="showProfileDrop == true"
							class="customDropdown profile show"
						>
							<div class="dropdownList">
								<button type="button" @click="goToMember()" class="dropdownBtn">
									האיזור האישי
								</button>
								<button type="button" @click="signOut()" class="dropdownBtn">
									התנתק
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>

		<HeaderTabs    v-if="$store.state.isPage"></HeaderTabs>
		<!-- <NearByToolbar    style="z-index: 20;"
		id="near_by_toolbar" ref="near_by_toolbar" /> -->

		<transition name="fade" mode="out-in">
			<NotFound v-if="$store.state.view == 'notfound'" />
			<HomeView v-if="$store.state.view == 'home'" />

			<!-- <div class="app_wrapper">


			</div> -->
			<NeighborhoodBuyView v-if="$store.state.view == 'neighborhood'" />
			<NeighborhoodRentView v-if="$store.state.view == 'neighborhood_rent'" />
			<NeighborhoodMaBasviva v-if="$store.state.view == 'neighborhood_info'" />
			<StreetsBuyView v-if="$store.state.view == 'street'" />
			<SettlementBuyView v-if="$store.state.view == 'settlement'" />
			<SettlementRentView v-if="$store.state.view == 'settlement_rent'" />
			<SettlementMaBasviva v-if="$store.state.view == 'settlement_info'" />
			<AddressBuyView v-if="$store.state.view == 'address'" />
			<KparcelBuyView v-if="$store.state.view == 'kparcel_all'" />
			<LogInCard v-if="$store.state.view == 'login'" />
			<ApproveUserToken v-if="$store.state.view == 'approve'" />
			<MemberView v-if="$store.state.view == 'member'" />
			<RegisterCard v-if="$store.state.view == 'register'" />
			<ResetPasswordCard v-if="$store.state.view == 'reset'" />
			<TermOfUse v-if="$store.state.view == 'termofuse'" />
			<AccessibilityView v-if="$store.state.view == 'accessibility'" />
			<AboutView v-if="$store.state.view == 'about'" />
		</transition>



		<div
			v-if="showContactMsg == true"
			role="dialog"
			aria-modal="true"
			class="fade contanctModal centerModal smModal titleContainer modal show"
			tabindex="-1"
			aria-labelledby="contained-modal-title-vcenter"
		>
			<div
				v-if="showContactMsg == true"
				class="modal-dialog modal-lg modal-dialog-centered"
			>
				<div class="modal-content">
					<button
						@click="showContactMsg = false"
						type="button"
						class="closeModalBtnContainer"
					>
						<span class="closeModalBtn" aria-hidden="true"></span
						><span class="sr-only">Close</span>
					</button>
					<div class="modalHeader contanctContainer">
						<h3 class="title">{{ contactText }}</h3>
						<p class="plainText">תודה רבה, מבטיחים שנעשה כל מאמץ להשתפר</p>
					</div>
					<div class="modalBody contanctContainer"></div>
				</div>
			</div>
		</div>

		<!-- open / close map-->
		<div
			v-if="$store.state.isPage"
			
			:style="{
				position: 'fixed',
				zIndex: 1000000010,
				left: '10px',


				top: $store.state.mapStatus == 0 ? '' : mapBtnTop,
				
				bottom: $store.state.mapStatus == 0 ? '50px' : ''
			}"
			class="icon1-circle"
		>
			<button @click="ShowMap()">			
				<div class="map-action-before"  v-show="$store.state.mapStatus == 0">
					<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#02234b"><path d="m574-129-214-75-186 72q-10 4-19.5 2.5T137-136q-8-5-12.5-13.5T120-169v-561q0-13 7.5-23t20.5-15l186-63q6-2 12.5-3t13.5-1q7 0 13.5 1t12.5 3l214 75 186-72q10-4 19.5-2.5T823-824q8 5 12.5 13.5T840-791v561q0 13-7.5 23T812-192l-186 63q-6 2-12.5 3t-13.5 1q-7 0-13.5-1t-12.5-3Zm-14-89v-468l-160-56v468l160 56Zm80 0 120-40v-474l-120 46v468Zm-440-10 120-46v-468l-120 40v474Zm440-458v468-468Zm-320-56v468-468Z"/></svg>
				</div>
				<div class="map-action-after"  v-show="$store.state.mapStatus > 0">
					<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#02234b"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
				</div>			
			</button>
		</div>
		<!-- $store.state.mapStatus == 0 ? '' : '160px', -->
		<!-- extend / minimize map-->
		<div
			v-if="$store.state.isPage && $store.state.mapStatus > 0"
			style="position: fixed; z-index: 1000000010; left: 10px; top: 210px "
			class="resize_map_icon"
		>	 
			<button @click="ResizeMap()">			
				<div class="map-action-before"  v-show="$store.state.mapStatus == 1">
					<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#02234b"><path d="M120-120v-240h80v104l124-124 56 56-124 124h104v80H120Zm480 0v-80h104L580-324l56-56 124 124v-104h80v240H600ZM324-580 200-704v104h-80v-240h240v80H256l124 124-56 56Zm312 0-56-56 124-124H600v-80h240v240h-80v-104L636-580Z"/></svg>
				</div>
				<div class="map-action-after"  v-show="$store.state.mapStatus == 2">
					<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#02234b"><path d="m156-100-56-56 124-124H120v-80h240v240h-80v-104L156-100Zm648 0L680-224v104h-80v-240h240v80H736l124 124-56 56ZM120-600v-80h104L100-804l56-56 124 124v-104h80v240H120Zm480 0v-240h80v104l124-124 56 56-124 124h104v80H600Z"/></svg>
				</div>			
			</button>
		</div>

		
		<footer
			class="footer"
			v-if="$store.state.loading == false && showFooter == true && !pages.includes($route.query.page)"
		>
			<div class="personalArea">
				<h3 class="title">עסקאות חדשות לידי? יש פרויקט חדש בשכונה?</h3>
				<p class="plainText">
					קבלו מידע עדכני על סביבת המגורים שלכם ישירות למייל
				</p>
			</div>
			<button @click="showRegister()" class="btn blue round">
				הירשמו לקבלת עדכונים
			</button>
			<ul class="footerLinks">
				<li class="linkWrap">
					<button type="button" @click="showContact()" class="link">
						יצירת קשר
					</button>
				</li>
				<li class="linkWrap">
					<button class="link" @click="goToTerms()">תנאי שימוש</button>
				</li>
				<li class="linkWrap">
					<button class="link" @click="goToAccess()">נגישות</button>
				</li>
				<li class="linkWrap">
					<button class="link" @click="goToAbout()">אודות</button>
				</li>
			</ul>
		</footer>


		<ContactModal v-if="$store.state.contactModal"></ContactModal>



		<UserLimitModal></UserLimitModal>

	</div>


	
</template>

<script
id="govmap_script"
src="https://www.govmap.gov.il/govmap/api/govmap.api.js"
></script>

<script>

	import HomeView from "./views/HomeView.vue";
	import NotFound from "./views/NotFound.vue";
	import NeighborhoodBuyView from "./views/NeighborhoodBuyView.vue";
	import NeighborhoodRentView from "./views/NeighborhoodRentView.vue";
	import NeighborhoodMaBasviva from "./views/NeighborhoodMaBasviva.vue";
	import StreetsBuyView from "./views/StreetsBuyView.vue";
	import SettlementBuyView from "./views/SettlementBuyView.vue";
	import SettlementRentView from "./views/SettlementRentView.vue";
	import SettlementMaBasviva from "./views/SettlementMaBasviva.vue";
	import AddressBuyView from "./views/AddressBuyView.vue";
	import KparcelBuyView from "./views/KparcelBuyView.vue";
	import LogInCard from "./views/LogInCard.vue";
	import ApproveUserToken from "./views/ApproveUserToken.vue";
	import MemberView from "./views/MemberView.vue";
	import RegisterCard from "./views/RegisterCard.vue";
	import ResetPasswordCard from "./views/ResetPasswordCard.vue";
	import TermOfUse from "./views/TermOfUse.vue";
	import AccessibilityView from "./views/Accessibility.vue";
	import AboutView from "./views/About.vue";
	import SearchBox from "./components/SearchBox.vue";
	import HeaderTabs from "./components/HeaderTabs";
	import ContactModal from "./components/ContactModal.vue";
	import UserLimitModal from "./components/UserLimitModal";

	// import NearByToolbar from "./components/NearByToolbar";

	export default {
		name: "App",
		components: {
			HomeView,
			NotFound,
			NeighborhoodBuyView,
			NeighborhoodRentView,
			NeighborhoodMaBasviva,
			StreetsBuyView,
			SettlementBuyView,
			SettlementRentView,
			SettlementMaBasviva,
			AddressBuyView,
			KparcelBuyView,
			LogInCard,
			ApproveUserToken,
			MemberView,
			RegisterCard,
			ResetPasswordCard,
			TermOfUse,
			AccessibilityView,
			AboutView,
			SearchBox,
			HeaderTabs,
			ContactModal,
			UserLimitModal,
			// NearByToolbar

		},
		data() {
			return {
				isRendered: false,
				pages: ['rent', 'deals', 'info'],
				searchMobileActive: false,
				showFooter: false,
				showProfileDrop: false,
				contactModal: false,
				showContactMsg: false,
				contactText: "",
				name: "",
				emailAddress: "",
				subject: "",
				application: "",
				recaptchaLoaded: false,
				recaptchaWidgetId: null,
				isRecaptchaValid: false,
				statusText: "",
				mapBtnTop: '160px',

			};
		},
		computed: {
			mapSelectionAllowed(){
				return this.$store.state.mapSelectionAllowed
			},
			showMap() {
				return this.$store.state.showMap;
			},
			isMobile() {
				return window.innerWidth < 768;
			},
			userLetters() {
				var first_last = "";
				if (this.currentUser.hasOwnProperty("userName")) {
					first_last = this.currentUser.userName.split(" ");
				}
				if (this.currentUser.hasOwnProperty("username")) {
					first_last = this.currentUser.username.split(" ");
				}
				var uppers = first_last.map((word) => word.charAt(0).toUpperCase());
				return uppers.join("");
			},
			config() {
				return this.$store.state.config;
			},
			currentUser() {
				if (this.$store.state.currentUser != null){
					return this.$store.state.currentUser;
				}
				if (this.mixin_getCookie('user') != null){
					var decompessed = this.decompressBase64Gzip(this.mixin_getCookie('user'));
					return decompessed;
				}
				else{
					return null;
				}
			},
		},
			


		mounted() {

			// Start a timer to count 10 seconds
			setTimeout(() => {
				if (!this.isRendered) {
					// If rendering is not complete after 10 seconds, refresh the page
					console.warn("Page did not render in time. Refreshing...");
					window.location.reload();
				}
			}, 20000); // 20000 ms = 20 seconds

			// Simulate rendering completion (replace this with your real condition)
			this.checkRenderingCompletion();

			window.addEventListener('resize', this.isMapVisible);
			var appVue = this;


			appVue.$store.state.loading = false;
			appVue.showFooter = false;
			setTimeout(function () {
				appVue.showFooter = true;
			}, 100);

			window.scrollTo(0, 0);

			appVue.$store.state.isMain = true;
			// dispatch(loadConfigAndNeigh)
			appVue.$store.dispatch("loadConfigAndNeigh").then(() => {
				if (appVue.$route.query.view != null) {
					appVue.$store.state.view = appVue.$route.query.view;
				} else {
					appVue.$store.state.view = "home";
				}
			});

			this.$store.state.userLimitModal = false;
			this.$store.state.contactModal = false;
		},
		methods: {

			checkRenderingCompletion() {
				// Simulate a delay for rendering check (replace with real logic)
				setTimeout(() => {
					this.isRendered = true; // Set this to true when rendering is complete
					//console.log("Rendering completed.");
				}, 5000); // Simulate rendering completion after 5 seconds
			},


			determineTop(){
				if (window.innerWidth < 768 ){
					return '120px';
				}
				else {
					return '160px';
				}
			
			},
			
			isMapVisible() { 
				// determine top of map botton icon
				this.mapBtnTop = this.determineTop();


				var queryPage = this.$route.query.page;
				var value = null;
				if (queryPage == 'rent' || queryPage == 'deals') {
					value = 1350;
				}
				else if (queryPage == 'info') {
					value = 1150;
				}

				const closeBtn_array =  document.getElementsByClassName("resize_map_icon");

				

				// מפה חצויה
				if (this.$store.state.mapStatus === 1) {
					const mapSideWrapperExists = document.getElementsByClassName("map_side_wrapper").length === 1;
					const isSmallScreen = window.innerWidth < value;
					
				

				
					// console.log( window.innerWidth, value , window.innerWidth > value ,'show');
				
					// console.log( window.innerWidth, value , window.innerWidth > value );
					if (closeBtn_array.length > 0) {
						if (window.innerWidth > value) {
							// console.log('if isBigScreen', 'show');
							closeBtn_array[0].style.display =   'block'
						}
						else {
							// console.log('if isSmallScreen', 'none');
							closeBtn_array[0].style.display =   'none'
						}
					}

				
					if (mapSideWrapperExists) {
						document.body.style.overflowY = isSmallScreen ? 'hidden' : 'auto';
						

					} else {
						document.body.style.overflowY = 'auto';
						

					}
				}
				
			},
			ShowMap(){
				if (this.$store.state.mapStatus == 1) {
					this.$store.state.mapStatus = 0;
					this.$store.state.showMap == false;
					document.body.style.overflowY ='auto';
				} 
				else if (this.$store.state.mapStatus == 2) {
					this.$store.state.mapStatus = 0;
					this.$store.state.showMap == false;
					document.body.style.overflowY ='auto';
					
				}
				else {
					this.$store.state.mapStatus = 1;
					this.$store.state.showMap == true;
					document.body.style.overflowY ='auto';
				}
				setTimeout(() => {
					this.isMapVisible();
				}, 300);

				
			},
			ResizeMap(){
				if (this.$store.state.mapStatus == 2) {
					this.$store.state.mapStatus = 1;
					document.body.style.overflowY ='auto';
					
				} else {
					this.$store.state.mapStatus = 2;

					document.body.style.overflowY = 'hidden';
				}
			},
			updateCurrentUser() {
				// Using the mixin method to get user data from cookies
				// decompress and set to currentUser
				if (this.mixin_getCookie('user')){
					var decompessed = this.decompressBase64Gzip(this.mixin_getCookie('user'));
					const userData = decompessed;
					if (userData && userData.userid) {
						this.$store.state.currentUser = userData;
					}
				}
			},
			goToAbout() {
				this.mixin_goTo(this, "about");
			},
			goToAccess() {
				this.mixin_goTo(this, "accessibility");
			},
			goToTerms() {
				this.mixin_goTo(this, "termofuse");
			},
			showRegister() {
				this.mixin_goTo(this, "register");
			},
			showContact() {
				// // get recaptcha
				// this.loadRecaptchaScript().then(() => {
				// 	// add class modal show to element id: contactModal...
				// 	var cm = document.getElementById("contactModal");
				// 	cm.classList.add("modal show");
				// 	this.contactModal = true;
				// });
				this.$store.state.contactModal = true;
			},
			goToMember() {
				this.showProfileDrop = false;
				this.mixin_goTo(this, "member");
			},
			signOut() {
				try {
					// Clear store state
					this.$store.state.currentUser = null;
					this.$store.state.userid = null;      // Clear if you have these
					this.$store.state.username = null;    // Clear if you have these
					this.$store.state.useremail = null;   // Clear if you have these
					
					// Clear all auth-related cookies
					this.mixin_removeCookie('up');
					this.mixin_removeCookie('user');
					
					// Update UI state
					this.showProfileDrop = false;
					this.$store.state.isMain = true;
					// Navigate home
					this.goHome();
				} catch (error) {
					console.error('Error during sign out:', error);
					// Still try to navigate home even if there's an error
					this.goHome();
				}
			},
			toggleProfileDrop() {
				this.showProfileDrop = !this.showProfileDrop;
			},
			goHome() {
				if (this.$store.state.view != "home") {
					this.$router.push({ name: "home" });
				}
			},
			login() {
				this.mixin_goTo(this, "login");
			},
			zoomCurrentLocation() {
				var appVue = this;
				appVue.mixin_zoomCurrentLocation(appVue);
			},
			async showResults() {
				var appVue = this;
				await appVue.mixin_showResults(appVue);
			},

			loadRecaptchaScript() {
				return new Promise((resolve, reject) => {
					const script = document.createElement("script");
					script.src =
						"https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
					script.async = true;
					script.defer = true;
					document.head.appendChild(script);

					window.onloadCallback = () => {
						this.recaptchaLoaded = true;
						resolve();
					};

					script.onerror = reject;
				});
			},
			renderRecaptcha() {
				if (this.recaptchaLoaded == true && window.grecaptcha) {
					var grecaptcha = window.grecaptcha;
					this.recaptchaWidgetId = grecaptcha.render("html_element", {
						sitekey: "6LfoK-kpAAAAADtjZ-gf0LQGxCm9iGAvzOa52_3-",
						callback: this.verifyCallback,
						"expired-callback": this.expiredCallback,
					});
				}
			},
			verifyCallback(response) {
				if (response) {
					this.isRecaptchaValid = true;
				}
			},
			expiredCallback() {
				this.isRecaptchaValid = false;
			},
			submitContact(recaptcha) {
				var appVue = this;
				var name = this.name;
				var emailAddress = this.emailAddress;
				var subject = this.subject;
				var application = this.application;

				// Validate input and reCAPTCHA
				if (!name || !emailAddress || !subject || !application) {
					// set error msg
					appVue.statusText = "נא למלא את כל השדות";
					return;
				}

				// Send data to server
				fetch(appVue.$store.state.config.api_base + "/ContactUs", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						name,
						emailAddress,
						subject,
						application,
						recaptcha,
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						// error sample object
						// {
						// 	"success": false,
						// 	"msgTitle": "נכשל השליחה",
						// 	"msgContent": "השדה name חייב להכיל לפחות 2 תווים"
						// }
						//when response false: show error msg

						if (data.success == false) {
							appVue.statusText = data.msgTitle + ": " + data.msgContent;
							return;
						}

						appVue.statusText = "הודעתך נשלחה בהצלחה!";
						if (window.grecaptcha) {
							var grecaptcha = window.grecaptcha;
							grecaptcha.reset();
						}

						//close modal after 3 seconds
						setTimeout(() => {
							appVue.contactModal = false;
							appVue.showContactMsg = true;
							appVue.contactText = "הודעתך נשלחה בהצלחה!";
						}, 1000);


						//return;
					})
					// {
					// 	"success": false,
					// 	"msgTitle": "נכשל השליחה",
					// 	"msgContent": "השדה name חייב להכיל לפחות 2 תווים"
					// }
					// when response false: show error msg
					// when response true: show success msg
										//.then(() => {
					// // 	appVue.statusText = "הודעתך נשלחה בהצלחה!";
					// 	appVue.statusText = "הודעתך נשלחה בהצלחה!";
					// 	if (window.grecaptcha) {
					// 		var grecaptcha = window.grecaptcha;
					// 		grecaptcha.reset();
					// 	}

					// 	//close modal after 3 seconds
					// 	setTimeout(() => {
					// 		appVue.contactModal = false;
					// 		appVue.showContactMsg = true;
					// 		appVue.contactText = "הודעתך נשלחה בהצלחה!";
					// 	}, 1000);
					// })
					.catch((error) => {
						console.error("Error:", error);
						//alert('התרחשה שגיאה בשליחת ההודעה');
						appVue.statusText = "התרחשה שגיאה בשליחת ההודעה";
					});
			},
			handleSubmit() {
				this.loadRecaptchaScript().then(() => {
					if (window.grecaptcha) {
						var grecaptcha = window.grecaptcha;
						const response = grecaptcha.getResponse(this.recaptchaWidgetId);
						if (response.length === 0) {
							alert("Please complete the reCAPTCHA");
							// recaptcha not completed
							appVue.statusText = "נא לאשר את הreCAPTCHA";
							return;
						} else {
							// Proceed with form submission
							// alert("Form submitted successfully");
							this.submitContact(response);
						}
					}
				});
			},
		},
		created() {
			this.updateCurrentUser();
		},
		watch: {
			// mapSelectionAllowed: function (val) {
			// 	if (val == true) {
			// 		// set mouse pointer to pointer
			// 		// TARGET
			// 		// POLYGON
			// 		// CIRCLE
			// 		// RECTANGLE
			// 		// SELECT_FEATURES
			// 		govmap.setMapCursor(govmap.cursorType.SELECT_FEATURES); 
			// 	}
			// 	else {
			// 		// set mouse pointer to default
			// 		govmap.setMapCursor(govmap.cursorType.DEFAULT); 
			// 	}
			// },
			
			showMap(after){
				if (after == true) {
					// scroll to map - only if query.page != rent
					if (this.$route.query.page != "rent") {
						setTimeout(() => {
							var elmnt = document.getElementById("map");
							elmnt.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
						}, 300);
					}
				}
			},
			$route(to, from) {
				if (
					to.query.view + "_" + to.query.page !=
					from.query.view + "_" + from.query.page
				) {
					if (to.query.view != null) {
						this.$store.state.view = to.query.view;
					} else {
						this.$store.state.view = "home";
					}
				}
			},
		},
	};
</script>


<style>
	/* * { */
	/* box-sizing: border-box; */
	/* } */


	.app_wrapper {
		display: flex;
		flex: 1 0 auto;
		flex-direction: column;
	}


	.map_side {
		z-index: 3;
		position: absolute;
		height: 100%;
		width: 100%;
		padding: 0px;
		border-width: 0px;
		margin: 0px;
		left: 0px;
		top: 0px;
		touch-action: pan-x pan-y;
	}

	.map_side_wrapper {
		position: absolute;
		height: 100%;
		width: 100%;
		padding: 0px;
		border-width: 0px;
		margin: 0px;
		left: 0px;
		top: 0px;
	}

	.info_side {
		width: 60%;
		position: relative;
		display: block;
		flex: 1 1 0%;
		transform: translateX(0%);
		transition: transform 850ms cubic-bezier(0.25, 1, 0.5, 1) 50ms;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s ease;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
		opacity: 0;
	}

	#app {
		-webkit-tap-highlight-color: transparent;
		background-color: #f1f4f9;
	}

	.headerActions .initialCircle {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative; /* Add this for positioning the green dot */
		width: 36px;
		height: 36px;
		background-color: #0d3efb; /* Match the fill color of the SVG icon */
		color: #fff; /* White text color */
		border-radius: 50%; /* Make it a circle */
		font-size: 18px; /* Adjust font size as needed */
		font-weight: bold; /* Optional: make the text bold */
		text-align: center;
		line-height: 40px; /* Center text vertically */
	}

	.headerActions .initialCircle .greenDot {
		position: absolute;
		top: 4px;
		right: -1px;
		width: 10px;
		height: 10px;
		background-color: #7af55e;
		border: 2px solid white;
		border-radius: 50%;
	}

	/*the container must be positioned relative:*/
	.autocomplete {
		position: relative;
		display: inline-block;
	}

	.autocomplete input {
		border: 1px solid transparent;
		background-color: white;
		padding: 10px;
		font-size: 18px;
	}

	.autocomplete-items {
		/* make the autocomplete sticky 
  position: fixed; */
		font-size: 18px !important;
		position: absolute;
		border: 1px solid #d4d4d4;
		/* border-bottom: none; */
		border-top: none;
		z-index: 99;
		/*position the autocomplete items to be the same width as the container:*/
		top: 100%;
		left: 0;
		right: 20px;

		overflow-y: auto;
		max-height: calc(
			100vh - 200px
		); /*todo mobile, calc, scroll on key up/down*/
		/* make corners round */
		border-radius: 10px;
		/* make the autocomplete sticky 
  position: fixed; */
	}

	.autocomplete-items::-webkit-scrollbar {
		width: 10px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888;
	}

	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}

	.autocomplete-items div {
		padding: 5px; /*10px*/
		cursor: pointer;
		background-color: #fff;
		z-index: 10000 important;

		position: "fixed";

		/* border-bottom: 1px solid #d4d4d4; */
	}

	/*when hovering an item:*/
	.autocomplete-items div:hover {
		background-color: #e9e9e9;
		z-index: 10000 important;
	}

	/*when navigating through the items using the arrow keys:*/
	.autocomplete-active {
		background-color: DodgerBlue !important;
		color: #ffffff;
	}

	.autocomplete-error-msg {
		display: block;
		position: absolute;
		top: 100%;
		right: 0px;
		z-index: 10;
		width: 100%;
		color: #ff5959;
		font-size: 20px;
		background: rgba(228, 228, 228, 0.77);
		text-align: center;
		margin-top: 5px;
	}

	.autocomplete-error-msg.show {
		visibility: visible;
		opacity: 1;
	}

	.autocomplete-error-msg.hide {
		visibility: hidden;
		opacity: 0;
		transition:
			visibility 0s 2s,
			opacity 2s linear;
	}

	.autocomplete-badge {
		font-size: 14px !important;
		position: absolute;
		left: 2px;
		font-weight: 400;
		border-radius: 50%;
		display: inline-block;
		text-align: center;
		padding-left: 8px;
		padding-right: 8px;
		opacity: 0.4;
	}

	* {
		box-sizing: border-box;
	}

	input[type="text"] {
		width: 100%;
	}

	input[type="submit"] {
		background-color: DodgerBlue;
		color: #fff;
		cursor: pointer;
	}

	input {
		border: 1px solid transparent;
		background-color: #f1f1f1;
		padding: 10px;
		font-size: 12px;
	}

	#ac-result,
	#ac-details {
		width: 100%;
	}

	.autocomplete,
	#subject-select,
	#ds-select {
		width: 200px !important;
	}
	@media screen and (min-width: 800px) {
		#ac-result #ac-details {
			padding-right: 310px;
		}

		.autocomplete,
		#subject-select,
		#ds-select {
			width: 40% !important;
		}
	}

	.map-action-before {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: 40px;
		height: 40px;
		
		background-color: #ffffff; /* You can change the background color */
		border-radius: 20%;
		box-shadow: 0px 0px 4px 0px rgb(60 64 67 / 50%); 
	}
	.map-action-after {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: 40px;
		height: 40px;
		background-color: #ffffff; /* You can change the background color */
		border-radius: 20%;
		box-shadow: 0px 0px 4px 0px rgb(60 64 67 / 50%);
	}



	.resize_map_icon {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: 40px;
		height: 40px;
		border-radius: 20%;

	}



</style>
